import { api } from '@/api/api-client';

export type PromoCode = {
  code: string;
  campaign: string;
  partnerName: string | null;
  active: boolean;
  createdAt: string;
};

export type PromoPartnerSale = {
  partnerCode: string | null;
  sales: number;
  grossCents: number;
};

// Generic promo/affiliate codes + partner sales (shared by any promo campaign; LTD is the first).
export const PromoService = {
  validateCode: async (
    code: string,
    campaign = 'ltd',
  ): Promise<{ valid: boolean; partner: string | null }> => {
    const { data } = await api.get<{ data: { valid: boolean; partner: string | null } }>(
      `/promos/validate?campaign=${encodeURIComponent(campaign)}&code=${encodeURIComponent(code)}`,
    );
    return data;
  },
  // Public: the signed-out sign-up page asks which offers are on.
  offers: async (): Promise<{ introOffer: boolean }> => {
    const { data } = await api.get<{ data: { introOffer: boolean } }>('/promos/offers');
    return data;
  },
  listCodes: async (): Promise<PromoCode[]> => {
    const { data } = await api.get<{ data: { codes: PromoCode[] } }>('/promos/codes');
    return data.codes;
  },
  createCode: async (input: {
    code: string;
    campaign?: string;
    partnerName?: string | null;
    active?: boolean;
  }): Promise<void> => {
    await api.post('/promos/codes', input);
  },
  getSales: async (): Promise<PromoPartnerSale[]> => {
    const { data } = await api.get<{ data: { sales: PromoPartnerSale[] } }>('/promos/sales');
    return data.sales;
  },
};
